import React from "react";
import { FormGroup, FormFeedback } from "reactstrap";
import numeral from "numeral";
import "./index.scss";
import { TextField } from "shared";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

interface CustomTextInputProps {
  data?: any;
  labels?: any;
  labelText?: string;
  callback: Function;
  attributeName: string;
  value?: any;
  type?: any;
  disabled?: boolean;
  isNumeric?: boolean;
  isDecimal?: boolean;
  note?: string;
  placeholder?: string;
  style?: object;
  invalid?: boolean;
  formFeedbackText?: string;
  inputBoxRows?: number;
  maxDate?: string;
  minDate?: string;
  dateFormat?: string;
  showMonthYearOnly?: boolean;
}

export default function CustomTextInput({
  data,
  labels,
  labelText,
  callback,
  attributeName,
  type = "text",
  disabled = false,
  isNumeric = false,
  isDecimal = false,
  placeholder = "",
  note,
  style,
  invalid,
  formFeedbackText,
  inputBoxRows,
  value,
  maxDate,
  minDate,
  dateFormat = "yyyy-MM-dd",
  showMonthYearOnly,
}: CustomTextInputProps) {
  let valueToDisplay = value || data?.[attributeName];

  if (isNumeric && !isDecimal && valueToDisplay) {
    valueToDisplay = numeral(valueToDisplay).format("0,0");
  }
  return (
    <div className="custom-attribute__text-input" style={style}>
      {labels && labels?.[attributeName] && (
        <span className="custom-attribute__text-input-label">
          {labels[attributeName]}
        </span>
      )}
      {labelText && (
        <span className="custom-attribute__text-input-label">{labelText}</span>
      )}
      <FormGroup>
        {(type == "date" && (
          <DatePicker
            selected={
              valueToDisplay
                ? moment(valueToDisplay, "YYYY-MM-DD").toDate()
                : disabled
                ? null
                : moment().toDate()
            }
            onChange={(date: any) => {
              const val = date ? moment(date).format("YYYY-MM-DD") : null;
              attributeName ? callback(attributeName, val) : callback(val);
            }}
            dateFormat={dateFormat}
            disabled={disabled}
            showYearDropdown
            showMonthYearPicker={showMonthYearOnly}
            maxDate={
              maxDate ? moment(maxDate, "YYYY-MM-DD").toDate() : undefined
            }
            minDate={
              minDate ? moment(minDate, "YYYY-MM-DD").toDate() : undefined
            }
          />
        )) || (
          <TextField
            type="outline"
            areaRows={inputBoxRows}
            textArea={type == "textarea"}
            readonly={disabled}
            placeholder={
              placeholder !== ""
                ? placeholder
                : attributeName
                ? data?.[attributeName]
                : value
            }
            invalid={invalid}
            value={valueToDisplay || ""}
            onChange={(e) => {
              let val = e.target.value;
              if (isNumeric) {
                val = val.replace(/[^0-9.]/g, "");
                if (isNaN(val) || !val) {
                  val = null;
                }
              }
              if (val == "") {
                val = null;
              }
              attributeName ? callback(attributeName, val) : callback(val);
            }}
          />
        )}
        {invalid && formFeedbackText && (
          <span className="custom-attribute__text-input-invalid">
            {formFeedbackText}
          </span>
        )}
      </FormGroup>
      {note && <p className="custom-attribute__text-input-note">{note}</p>}
    </div>
  );
}
